import styled from "styled-components";

export const RpmProfileReportsRowLayout = styled.div`
    
    width:100%;
    margin-left:10px;
    height:100%;
    display:grid;
    grid-template-columns:repeat(2,1fr);
    grid-gap:15px;
    grid-auto-rows:minmax(290px,auto);


    .rpm-profile-grid-item{

        border-radius: 10px;
        background-color: #F4F6F8;
        padding:10px;
        
    }


    .rpm-profile-report-list{

        grid-column-start: 1;
        grid-column-end: 3;

    }


    
`